import script from "./PieChart.vue?vue&type=script&setup=true&lang=js"
export * from "./PieChart.vue?vue&type=script&setup=true&lang=js"

import "./PieChart.vue?vue&type=style&index=0&id=561808d1&lang=less"

const __exports__ = script;

export default __exports__